import snapshotUrl from './rennes-snapshot.svg';
import type { HomeReference } from './types';

/** Export du rendu Rennes approuvé, 03/11/2026 ; aucun accès GIS à l'exécution. */
export async function loadHomeReference(): Promise<HomeReference> {
  return { snapshotUrl, buildingCount: 23594 };
}
